const tooltipFormService = {
  goToPlace: 'Ir para os detalhes do local',
  goToEquipment: 'Ir para os detalhes do equipamento'
};

export default tooltipFormService;
